import { createSlice } from "@reduxjs/toolkit";

import { fetchArchivedOpportunitiesByReason } from "./actions";

export const initialState = {
  data: null,
  isLoading: false,
  error: null,
};

const DEFAULT_ERROR = "Failed to load archived opportunities by reason.";

const archivedOpportunitiesByReasonSlice = createSlice({
  name: "archivedOpportunitiesByReason",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchArchivedOpportunitiesByReason.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchArchivedOpportunitiesByReason.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
      })
      .addCase(fetchArchivedOpportunitiesByReason.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error?.message ?? DEFAULT_ERROR;
      });
  },
});

export default archivedOpportunitiesByReasonSlice.reducer;
